// Вспомогательные функции для URL
export const getApiUrl = () => {
  return process.env.REACT_APP_API_URL || '/api';
};

export const getBaseUrl = () => {
  // В production используем относительные пути, в development - localhost
  if (process.env.NODE_ENV === 'production') {
    return '';
  }
  return process.env.REACT_APP_BASE_URL || 'http://localhost:5001';
};

export const getUploadsUrl = () => {
  return process.env.REACT_APP_UPLOADS_URL || '/uploads';
};

export const getImageUrl = (imagePath, options = {}) => {
  if (!imagePath) return null;
  
  // Если путь уже полный URL, возвращаем как есть
  if (imagePath.startsWith('http')) return imagePath;
  
  // Статические изображения из /images/ остаются как есть (обслуживаются nginx из public)
  if (imagePath.startsWith('/images/')) {
    return imagePath;
  }
  
  // В production по умолчанию — относительный путь через nginx (быстрее CDN/статик)
  // Но если включен флаг REACT_APP_USE_OPTIMIZED_UPLOADS, бьём прямо в backend,
  // чтобы работали параметры w/h/format и кеширование через imageOptimizer.
  if (process.env.NODE_ENV === 'production') {
    const useOptimized = process.env.REACT_APP_USE_OPTIMIZED_UPLOADS === 'true';
    const baseUploads = useOptimized
      ? (process.env.REACT_APP_API_URL || '').replace(/\/api$/, '') || ''
      : '';

    let url = imagePath.startsWith('/uploads/') 
      ? `${baseUploads}${imagePath}` 
      : `${baseUploads}/uploads/${imagePath.replace(/^\/+/, '')}`;

    // Параметры для ресайза через imageOptimizer (только если backend поддерживает)
    const qp = [];
    if (options.w) qp.push(`w=${options.w}`);
    if (options.h) qp.push(`h=${options.h}`);
    if (options.format) qp.push(`format=${options.format}`);
    if (options.q) qp.push(`q=${options.q}`);
    if (qp.length) {
      const separator = url.includes('?') ? '&' : '?';
      url += separator + qp.join('&');
    }

    // Добавляем cache busting только по явному флагу
    if (options.bustCache) {
      const separator = url.includes('?') ? '&' : '?';
      url += `${separator}v=${Date.now()}`;
    }
    
    return url;
  }
  
  // В development используем прямой доступ к backend
  const baseUrl = getBaseUrl();
  let url = imagePath.startsWith('/uploads/') 
    ? `${baseUrl}${imagePath}` 
    : `${baseUrl}/${imagePath.replace(/^\/+/, '')}`;

  const qp = [];
  if (options.w) qp.push(`w=${options.w}`);
  if (options.h) qp.push(`h=${options.h}`);
  if (options.format) qp.push(`format=${options.format}`);
  if (options.q) qp.push(`q=${options.q}`);
  if (qp.length) {
    const separator = url.includes('?') ? '&' : '?';
    url += separator + qp.join('&');
  }
  
  // Добавляем cache busting только по явному флагу
  if (options.bustCache) {
    const separator = url.includes('?') ? '&' : '?';
    url += `${separator}v=${Date.now()}`;
  }
  
  return url;
};

// Специальная функция для админпанели с принудительным cache busting и уменьшением превью
export const getAdminImageUrl = (imagePath, opts = {}) => {
  const { w, h, format, q, bustCache = false } = opts;
  return getImageUrl(imagePath, { isAdmin: true, bustCache, w, h, format, q });
};
